import { PropertyCurrencies } from "@/types/property-config";

// Currency Symbol Mapper Helper
export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) return "₦";

  switch (currency.toUpperCase()) {
    case PropertyCurrencies.USD:
    case "$":
      return "$";
    case PropertyCurrencies.GBP:
    case "£":
      return "£";
    case "CAD":
      return "C$";
    case "EUR":
      return "€";
    case "CNY":
      return "¥";
    case PropertyCurrencies.NGN:
    case "₦":
    default:
      return "₦";
  }
};

/**
 * Formats numbers into compact notation for large values (Millions/Billions)
 * @param val - Number or string value to format
 * @param currency - PropertyCurrencies enum value, currency string code ('NGN', 'USD', 'GBP'), or symbol ('₦', '$', '£')
 */
export const formatPrice = (
  val: number | string = 0,
  currency: PropertyCurrencies | string = PropertyCurrencies.NGN,
) => {
  const num = typeof val === "string" ? parseFloat(val) : val;
  const symbol = getCurrencySymbol(currency);

  if (!num || isNaN(num)) return `${symbol} 0`;

  // For 100 Million and above, format as compact (M / B)
  if (Math.abs(num) >= 100_000_000) {
    const formatted = new Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 2,
    }).format(num);
    return `${symbol} ${formatted}`;
  }

  // Standard full number for smaller values
  return `${symbol} ${num.toLocaleString()}`;
};
